import { useCallback, useEffect, useState } from 'react';
import apiClient from '../services/api';

// 21 sep 2026 (Augusto: "debería permitir importar todo a PCM pero una
// vez dentro, colocar alertas (con indicadores numéricos) de los
// problemas encontrados que se tienen que solucionar").
//
// El contador rojo de movimientos que entraron pero esperan una
// decisión. Mismo mecanismo que useConsultasPendientes, con una
// diferencia importante: este lo consulta CUALQUIER usuario, no solo el
// admin -- es una función del producto, no del panel interno.
//
// Este indicador carga más peso que el de consultas: mientras haya
// pendientes, los totales del usuario están deliberadamente incompletos
// (lo pendiente no suma, ver models/transaction.py en el backend). Si el
// número no se ve, la persona cree que su tablero está completo cuando
// no lo está. Por eso aparece en la barra, en el header, y con el detalle
// en su propia pantalla.

const INTERVALO_MS = 60000;

export const EVENTO_ACTUALIZAR = 'pcm:revisiones-actualizadas';

/** Avisa a los contadores que algo cambió, sin esperar al próximo ciclo. */
export const avisarRevisionesActualizadas = () => {
  window.dispatchEvent(new Event(EVENTO_ACTUALIZAR));
};

export const useRevisionesPendientes = () => {
  const [pendientes, setPendientes] = useState(0);

  const refrescar = useCallback(() => {
    apiClient
      .get('/transactions/pendientes/count')
      .then((res) => setPendientes(res.data?.pendientes || 0))
      .catch(() => {
        // Silencio deliberado: el contador es informativo y no debe
        // romper la barra lateral si el backend no responde.
      });
  }, []);

  useEffect(() => {
    refrescar();
    const id = setInterval(refrescar, INTERVALO_MS);
    const alVolver = () => {
      if (document.visibilityState === 'visible') refrescar();
    };
    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener(EVENTO_ACTUALIZAR, refrescar);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', alVolver);
      window.removeEventListener(EVENTO_ACTUALIZAR, refrescar);
    };
  }, [refrescar]);

  return { pendientes, refrescar };
};

export default useRevisionesPendientes;
